import { render, staticRenderFns } from "./ReleaseTicket.vue?vue&type=template&id=a5915786&scoped=true&"
import script from "./ReleaseTicket.vue?vue&type=script&lang=js&"
export * from "./ReleaseTicket.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseTicket.vue?vue&type=style&index=0&id=a5915786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5915786",
  null
  
)

export default component.exports